import cn from '@/lib/clsxm';

import { SIZE_ENUM } from '@/components/@base/@helpers/types';
import Card, { CardContent } from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';

import { DATA_CY_ABOUT_BENEFIT_CARD } from '@/constant/cypress';

type itemProps = { text: string; color: string };
type BenefitCardProps = {
  data: {
    title: itemProps;
    subTitle: itemProps;
    description: itemProps;
    iconName: React.ReactNode;
  };
};

export default function BenefitCard({
  data: { description, title, subTitle, iconName },
}: BenefitCardProps) {
  return (
    <Card data-cy={DATA_CY_ABOUT_BENEFIT_CARD} noShadow className='flex min-h-[277px] max-w-72 flex-1 border-2 ' center>
      <CardContent className='flex flex-1 flex-col items-center justify-between px-10 py-12 text-center'>
        {iconName}
        <Container>
          <Text
            className={cn('text-3xl font-[700] leading-[46px] tracking-tighter', title.color)}
          >
            {title.text}
          </Text>
          <Text
            size={SIZE_ENUM.SM}
            bold
            className={cn('font-light text-[13px] leading-5 tracking-tighter', subTitle.color)}
          >
            {subTitle.text}
          </Text>
        </Container>
        <Text
          size={SIZE_ENUM.SM}
          type={TEXT_TYPE.P}
          bold
          className={cn(
            'font-light text-[13px] leading-5 tracking-tighter',
            description.color,
          )}
        >
          {description.text}
        </Text>
      </CardContent>
    </Card>
  );
}
